<template>
	<div><span class="biaoti">文章管理</span>
		<el-tabs type="border-card" v-model="tabs" @tab-remove="Tabremove">
			<el-tab-pane label="文章列表" name="lie">

				<el-collapse style="margin-top: 40px;margin-left: 10px;">
					<el-collapse-item title="筛选" name="1">
						<el-form ref="form" :model="so" label-width="80px" style="margin-left: 80px;">
							<el-form-item label="关键字">
								<el-input v-model="so.name"></el-input>
							</el-form-item>
							<el-form-item label="分类">
								<el-select v-model="so.leibie" placeholder="请选择1级分类" style="width: 100%;">
									<el-option label="请选择1级分类" value="buxianjuese"></el-option>
								</el-select>
							</el-form-item>
							<el-button size="medium" type="info" style="margin-left: 80px;" @click="CSH">搜索</el-button>
						</el-form>
					</el-collapse-item>
				</el-collapse>
				<el-table :data="shu.lie">
					<el-table-column prop="id" label="" width="80">
						<template slot="header" slot-scope="scope" style="width: 10%;">
							<el-checkbox></el-checkbox><span style="" class="shang">删</span>
						</template>
						<el-checkbox></el-checkbox>
					</el-table-column>
					<el-table-column prop="id" label="ID" width="100"></el-table-column>
					<el-table-column prop="paixu" label="排序" width="100"></el-table-column>

					<el-table-column label="图片" width="120">
						<template slot-scope="shu">
							<el-image style="width: 30px; height: 30px" :src="shu.row.tu"></el-image>
						</template>
					</el-table-column>
					<el-table-column prop="biaoti" label="标题" width="180"></el-table-column>
					<el-table-column prop="shijian" label="时间" width="180"></el-table-column>
					<el-table-column label="状态" width="120">
						<template slot-scope="shu">
							<el-switch v-model="shu.row.zhuangtai" active-value="1" inactive-value="0" @change="Shenhe(shu.row)" />
						</template>
					</el-table-column>

					<el-table-column prop="caozuo" label="操作">
						<template slot-scope="shu">
							<el-button icon="el-icon-edit-outline" size="mini" @click="Mianbandakai(['wenzhang',shu.row])"></el-button>
							<el-button icon="el-icon-close" size="mini" @click="Shanchu(shu.row)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination background layout="total,prev,pager,next,jumper" :total="shu.zongshu" :page-size="jitiao"
				 :current-page.sync="ye" @current-change="CSH" style="margin-top: 30px;" />

			</el-tab-pane>
			<el-tab-pane :label="mianban_shu.id?'编辑':'新增'" name="xinzeng" :closable="mianban_shu.id>0">
				<div class="demo-drawer__content">
					<el-form :model="mianban_shu" style="width: 50%;">
						<el-form-item label="排序" label-width="100px">
							<el-input v-model="mianban_shu.paixu" />
						</el-form-item>
						<el-form-item label="标题" label-width="100px">
							<el-input v-model="mianban_shu.biaoti" />
						</el-form-item>
						<el-form-item label="关键字" label-width="110px">
							<el-input v-model="mianban_shu.guanjianci" />
						</el-form-item>
						<el-form-item label="来源" label-width="100px">
							<el-input v-model="mianban_shu.laiyuan" />
						</el-form-item>
						<el-form-item label="作者" label-width="100px">
							<el-input v-model="mianban_shu.zuozhe" />
						</el-form-item>
						<el-form-item label="缩略图" label-width="100px">
							<Shangwenjian v-model="mianban_shu.tu" leixing="tu" anniu="上传图片"></Shangwenjian>
						</el-form-item>
						<el-form-item label="文章类别" label-width="100px">
							<Liandong :yiji.sync="mianban_shu.yijifenlei" :erji.sync="mianban_shu.erjifenlei" :shu="fenleilie"></Liandong>
						</el-form-item>
						<el-form-item label="简介" label-width="100px">
							<el-input type="textarea" v-model="mianban_shu.jianjie" />
						</el-form-item>
						<el-form-item label="内容" label-width="100px">
							<Bianjiqi v-model="mianban_shu.neirong"></Bianjiqi>
						</el-form-item>
						<el-form-item label="直接链接" label-width="100px">
							<el-input v-model="mianban_shu.url" />
						</el-form-item>
						<el-form-item label="阅读次数" label-width="100px">
							<el-input v-model="mianban_shu.cishu" />
						</el-form-item>
					</el-form>
					<div class="demo-drawer__footer" style="margin-bottom: 50px; margin-left: 40px;">
						<Tijiao type="danger" @click="Mianban_post('wenzhang')">提 交</Tijiao>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!-- 编辑文章 -->
	</div>
</template>

<script>
	let that;
	import Shangwenjian from '../../zujian/Shangwenjian.vue'
	import Bianjiqi from '../../zujian/Bianjiqi.vue'
	import Liandong from '../../zujian/Liandong.vue'
	export default {
		data() {
			return {
				ye: 1,
				jitiao: 20,
				shu: {
					lie: [],
					zongshu: 0
				},
				so: {},
				mianban: {
					wenzhang: false,
				},
				mianban_shu: {},
				fenleilie: [],
				tabs: 'lie'
			}
		},
		components: {
			Shangwenjian,
			Bianjiqi,
			Liandong
		},
		created() {
			that = this;
			this.CSH();
			this.Fenlei();
		},
		methods: {
			CSH() {
				that.so.ye = that.ye;
				that.so.jitiao = that.jitiao;
				that.$post('k=wenzhang', that.so, function(s) {
					that.shu = s.shu;
				});
			},
			Mianbandakai(e) {
				that.tabs = 'xinzeng';
				that.mianban_shu = e[1] || {};
			},
			Mianban_post(e) {
				if (e == 'wenzhang') {					
					this.$post('k=wenzhang&c=Xiugai', that.mianban_shu, function(s) {
						that.$xiaoxi(s.shu);
						if (s.shi == 1) {
							that.CSH();
							if (!that.mianban_shu.id) {
								that.Tabremove();
							}
						}
					});
				}
				that.mianban[e] = false;
			},
			Shanchu(e){
				this.$post('k=wenzhang&c=shanchu',{id:e.id}, function(s) {
					that.$xiaoxi(s.shu);
					if (s.shi == 1) {
						that.CSH();						
					}
				});
			},
			Shenhe(e) {
				this.$post('k=wenzhang&c=xiugai', {
					id: e.id,
					zhuangtai: e.zhuangtai
				}, function(s) {
					if (s.shi != 1) {
						that.$xiaoxi(s.shu);
					}
				});
			},
			Fenlei() {
				this.$post('k=wenzhang&c=quanbufenlei', function(s) {
					if (s.shi == 1) {
						that.fenleilie = s.shu;
					}
				});

			},
			Tabremove(e) {
				that.tabs = 'lie';
				that.mianban_shu = {};
			},
		}
	}
</script>
<style scope>
	.annui {
		display: flex;
		justify-content: flex-start;
	}

	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}

	.tishi {
		color: #737373;
	}

	.el-icon-circle-plus-outline {
		position: absolute;
		right: 10px;
		top: 10px;

	}

	.shang {
		margin-left: 6px;
		cursor: pointer;
	}
</style>
